import { render, staticRenderFns } from "./NewsElement.vue?vue&type=template&id=7040c27c&scoped=true&"
import script from "./NewsElement.vue?vue&type=script&lang=js&"
export * from "./NewsElement.vue?vue&type=script&lang=js&"
import style0 from "./NewsElement.vue?vue&type=style&index=0&id=7040c27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7040c27c",
  null
  
)

export default component.exports